import { ColumnDef } from '@tanstack/react-table'
import { VitalDataMock } from '@type/vital.type'
import { Table2 } from '@ui'
import { useMemo } from 'react'
import { patientHistoryTableClassName } from './tableStyles'

type Props = {
  records: VitalDataMock[]
  isLoading?: boolean
}

const formatCapturedAt = (vital: VitalDataMock) => {
  const date = vital.attributes.captured_date
  const time = vital.attributes.time
  if (!date && !time) return '-'
  if (date && time) return `${new Date(date).toLocaleDateString()} ${time}`
  if (date) return new Date(date).toLocaleDateString()
  return time || '-'
}

export default function VitalsResultsTable({ records, isLoading }: Props) {
  const columns = useMemo<ColumnDef<VitalDataMock>[]>(
    () => [
      {
        accessorKey: 'vital_type',
        header: 'Vital',
        cell: ({ row }) => <span className="capitalize">{row.original.attributes.vital_type || '-'}</span>
      },
      {
        accessorKey: 'value',
        header: 'Value',
        cell: ({ row }) => {
          const { value, unit } = row.original.attributes
          return (
            <span>
              {value ?? '-'}
              {unit ? ` ${unit}` : ''}
            </span>
          )
        }
      },
      {
        accessorKey: 'captured_date',
        header: 'Recorded',
        cell: ({ row }) => <span>{formatCapturedAt(row.original)}</span>
      }
    ],
    []
  )

  return (
    <Table2
      className={patientHistoryTableClassName}
      columns={columns}
      data={records}
      emptyDescription="No vital signs have been recorded for you yet."
      isLoading={isLoading}
      message="No vitals yet"
    />
  )
}
